import { createFileRoute } from '@tanstack/react-router'

import { ConfirmStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/confirm')({
    component: ConfirmStep,
})
